<template>
  <div v-if="isDisplay" class="similar-fac">
    <h2 class="sub-heading">
      {{ title }}
    </h2>
    <ul>
      <li v-for="(city, index) in cities" :key="index">
        <nuxt-link :to="city.url">{{ city.title }}</nuxt-link>
      </li>
    </ul>
  </div>
</template>

<script>
import { createUrl } from '@/utils/create-url'
import { methods } from '@/utils/methods'
export default {
  props: {
    detail: {
      type: Object,
      required: true
    },
    cityList: {
      type: Array,
      required: true
    }
  },
  computed: {
    title() {
      return this.detail.prefecture + 'の貸し会議室を探す'
    },
    cities() {
      if (!this.isDisplay) {
        return []
      }

      // 名前順に並べ替え
      const sortedCityList = methods.sortFacetCity(this.cityList)

      return sortedCityList.map((city) => {
        const cityname = Object.keys(city)[0]
        const query = {
          prefecture: this.detail.prefecture,
          city: cityname
        }
        const title = cityname + 'の貸し会議室'
        const url = createUrl.createSearchUrl(query)
        return { title, url }
      })
    },
    isDisplay() {
      return this.cityList && this.cityList.length
    }
  }
}
</script>
